import Image from '@base/FutureImage';
import styled from '@emotion/styled';
import useWindowSize from '@hooks/useWindowSize';
import { mediaQuery, Spacings } from '@styles/index';
import Carousel from 'aquilla/core/molecules/Carousel';
import GridContainer from '@cont/CitySpecificOfflineCentres/CommonComponents';

const StyGridContainer = styled(GridContainer)`
  width: 100%;
  padding-top: ${Spacings.SPACING_10B};
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    padding-top: ${Spacings.SPACING_6B};
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: ${Spacings.SPACING_4B};
    border-bottom: none;
  }
  ${mediaQuery.uptoTablet} {
    padding-top: ${Spacings.SPACING_6B};
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: ${Spacings.SPACING_4B};
    border-bottom: none;
  }
`;

const StyCarousel = styled(Carousel)`
  & .aquilla-carousel-wrapper {
    ${mediaQuery.uptoMobile} {
      padding-left: 0px;
      gap: ${Spacings.SPACING_3B};
      div {
        width: 320px;
        height: 220px;
      }
      div:last-child {
        width: 320px;
        height: 220px;
      }
    }
  }
`;

const Container = styled.div`
  grid-column: span 24;

  ${mediaQuery.uptoTablet} {
    margin: 0;
    width: 100%;
  }
`;

const Section = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_4B};
  overflow-x: clip;
  ${mediaQuery.uptoMobile} {
    gap: ${Spacings.SPACING_2B};
  }
  ${mediaQuery.uptoTablet} {
    gap: ${Spacings.SPACING_2B};
  }
`;

const StyImage = styled(Image)`
  border-radius: ${Spacings.SPACING_2B};
  object-fit: cover;
`;

const AllCentreRankersCarousel = ({ rankerImages }) => {
  const { isMobile } = useWindowSize();

  const renderWebView = () => {
    return (
      <>
        <Section>
          <StyCarousel
            itemsPerSlide={2}
            variant="multiple"
            mode="auto"
            controls={{ showArrows: true }}
          >
            {rankerImages.map((imgSrc, i) => (
              <StyImage
                src={imgSrc}
                width={560}
                height={350}
                key={`carousel-${imgSrc}`}
                alt={`img-${i}`}
              />
            ))}
          </StyCarousel>
        </Section>
      </>
    );
  };

  const rendermWebView = () => {
    return (
      <>
        <Section>
          <StyCarousel
            itemsPerSlide={1}
            variant="multiple"
            mode="auto"
            controls={{ showArrows: true }}
          >
            {rankerImages.map((imgSrc, i) => (
              <StyImage
                src={imgSrc}
                key={`carousel-${imgSrc}`}
                alt={`img-${i}`}
                width={320}
                height={220}
              />
            ))}
          </StyCarousel>
        </Section>
      </>
    );
  };

  return (
    <StyGridContainer>
      <Container> {isMobile ? rendermWebView() : renderWebView()}</Container>
    </StyGridContainer>
  );
};

export default AllCentreRankersCarousel;
